import { useUserToken } from "@/store/userStore";
import { useCallback, useEffect } from "react";
import { useRouter } from "../hooks";

type Props = {
	children: React.ReactNode;
};
export default function AuthGuard({ children }: Props) {
	const router = useRouter();
	const { token } = useUserToken();

	const check = useCallback(() => {
		if (!token) {
			router.replace("/auth/login");
		}
	}, [router, token]);

	useEffect(() => {
		check();
	}, [check]);

	return <>{children}</>;
}
